import script from "./Cuotas.vue?vue&type=script&setup=true&lang=js"
export * from "./Cuotas.vue?vue&type=script&setup=true&lang=js"

import "./Cuotas.vue?vue&type=style&index=0&id=758f7e97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758f7e97"]])

export default __exports__